import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError } from 'common/repositories/common.model';

import { ReportExportExcelInput, ReportTourExportInput } from './model';

export function useReportTourExport(
  options?: UseMutationOptions<any, ApiError, ReportTourExportInput>,
): UseMutationResult<any, ApiError, ReportTourExportInput> {
  return useMutation<any, ApiError, ReportTourExportInput>(async function (
    body,
  ) {
    return await MutationFetchFunction({
      url: `reports/tour/${body.tourRefId}/export`,
      method: 'POST',
    });
  },
  options);
}

export function useReportExportExcel(
  options?: UseMutationOptions<any, ApiError, ReportExportExcelInput>,
): UseMutationResult<any, ApiError, ReportExportExcelInput> {
  return useMutation<any, ApiError, ReportExportExcelInput>(async function (
    body,
  ) {
    return await MutationFetchFunction({
      url: `reports/${body.type}/export`,
      method: 'POST',
      body: body.body,
    });
  },
  options);
}
